import { formatWithSymbolAndSeparator } from 'mr-components';
import { createStorefrontCart } from './storeFrontCart';
import { logger } from '../common/logger';
import { getCookieValue } from '../common/cookies';
import {
  getFreeShippingCodefromStorage,
  getGraphqlCachedData,
  getMonkAppliedCodes,
  getShopifyMonkCodesMapping,
} from '../common/settings';
import { logRuntimeError } from '../common/utils';

// export async function getDiscountedCart(discountCode) {
//   // get or create checkout
//   const applications = await applyDiscountCode(discountCode);
//   const { checkout } = applications;
//   if (checkout) {
//     const { discount_codes } = checkout;
//     logger.log(discount_codes);
//   }
// }

// async function getCartTokenFromAPI() {
//   const cart = await fetchCart();
//   const { token } = cart;
//   return token;
// }

// async function getCartToken() {
//   let cartToken = getFunctionsCheckoutConfig('cartToken');
//   if (cartToken) {
//     return cartToken;
//   }

//   cartToken = await getCartTokenFromAPI();
//   setFunctionsCheckoutConfig({ key: 'cartToken', value: cartToken });
//   return cartToken;
// }

// function getCheckoutToken() {
//   return getFunctionsCheckoutConfig('checkoutToken');
// }

// function setCheckoutToken(token) {
//   logger.log(token);
//   setFunctionsCheckoutConfig({ key: 'checkoutToken', value: token });
// }

// async function getCheckoutAccessTokenFromAPI() {
//   const resp = await fetch('/payments/config');
//   const data = await resp.json();
//   const {
//     paymentInstruments: { accessToken },
//   } = data;
//   return accessToken;
// }

// async function getCheckoutAccessToken() {
//   let accessToken = getFunctionsCheckoutConfig('accessToken');
//   if (accessToken) {
//     return accessToken;
//   }

//   accessToken = await getCheckoutAccessTokenFromAPI();
//   setFunctionsCheckoutConfig({ key: 'accessToken', value: accessToken });
//   return accessToken;
// }

// function getCheckoutRequestOptions({ accessToken, body, method }) {
//   return {
//     headers: {
//       authorization: `Basic ${window.btoa(accessToken)}`,
//       'content-type': 'application/json',
//     },
//     method,
//     body: JSON.stringify(body),
//     credentials: 'omit',
//   };
// }

// async function applyDiscountCode(code) {
//   const accessToken = await getCheckoutAccessToken();
//   const checkoutToken = getCheckoutToken() || '';
//   const cartToken = await getCartToken();
//   const method = checkoutToken ? 'PUT' : 'POST';
//   const URL = `/wallets/checkouts/${checkoutToken}`;
//   const body = {
//     checkout: {
//       cart_token: cartToken,
//       gift_cards: [],
//     },
//   };

//   if (code) {
//     body.checkout.discount_code = code;
//   }

//   const options = getCheckoutRequestOptions({ accessToken, body, method });
//   const resp = await fetch(URL, options);
//   const data = await resp.json();
//   const { checkout } = data;
//   if (checkout) {
//     const { token } = checkout;
//     setCheckoutToken(token);
//   }
//   return data;
// }

// const functionsConfigKey = 'mrFunctionDiscountConfig';
// function setFunctionsCheckoutConfig({ key, value }) {
//   let data = sessionStorage.getItem(functionsConfigKey);
//   if (!data) {
//     data = '{}';
//   }
//   const parsed = JSON.parse(data);
//   parsed[key] = value;
//   sessionStorage.setItem(functionsConfigKey, JSON.stringify(parsed));
// }

// function getFunctionsCheckoutConfig(key) {
//   const data = sessionStorage.getItem(functionsConfigKey);
//   if (!data) {
//     return undefined;
//   }
//   const parsed = JSON.parse(data);
//   return parsed[key];
// }

const getDiscountMilestoneIndex = milestones =>
  milestones.findIndex(milestone =>
    milestone.rewards.some(reward => reward.rewardType === 'discount'),
  );

export const storeShopifyFunctionsOfferData = ({ offer }) => {
  const {
    isShopifyFunctionsDiscountApplicable,
    shopifyFunctionsDiscountTitle,
    type,
  } = offer;

  if (!isShopifyFunctionsDiscountApplicable) {
    return;
  }

  const data = getShopifyFunctionsProductData();
  const existingProducts = data[shopifyFunctionsDiscountTitle] || [];

  let newProductIDs = [];
  switch (type) {
    case 'vd':
      newProductIDs = getVDProductIDs({ offer });
      break;

    case 'cvb':
      {
        const cvbData = getCVBProductIDsAndMap({ offer });
        newProductIDs = cvbData.productIDs;
      }
      break;

    default:
      newProductIDs = getCommonProductIDs({ offer });
      break;
  }
  const updatedProductIDs = new Set([...existingProducts, ...newProductIDs]);
  data[shopifyFunctionsDiscountTitle] = [...updatedProductIDs];
  setShopifyFunctionsProductData(data);
};

export const storeShopifyFunctionsCVBData = ({ offer }) => {
  const cvbFunctionsData = getShopifyFunctionsCVBData();

  const {
    milestones,
    cvbCartValue,
    cvbCartQuantityValue,
    shopifyFunctionsDiscountTitle,
  } = offer;
  if (!milestones) return;

  const cvbDiscountMilestoneIndex = getDiscountMilestoneIndex(milestones);
  const isPriceValueType = milestones[0].valueType === 'price';

  cvbFunctionsData[shopifyFunctionsDiscountTitle] = false;

  if (cvbDiscountMilestoneIndex !== -1) {
    if (
      isPriceValueType &&
      milestones[cvbDiscountMilestoneIndex].minValue <= cvbCartValue
    ) {
      cvbFunctionsData[shopifyFunctionsDiscountTitle] = true;
    }
    if (
      !isPriceValueType &&
      milestones[cvbDiscountMilestoneIndex].minValue <= cvbCartQuantityValue
    ) {
      cvbFunctionsData[shopifyFunctionsDiscountTitle] = true;
    }
  }

  setShopifyFunctionsCVBData(cvbFunctionsData);
};

const shopifyFunctionsDataKey = 'mrSFDCP';
const setShopifyFunctionsProductData = data => {
  sessionStorage.setItem(shopifyFunctionsDataKey, JSON.stringify(data));
};

export const getShopifyFunctionsProductData = () => {
  const data = sessionStorage.getItem(shopifyFunctionsDataKey);
  if (data) {
    const parsed = JSON.parse(data);
    return parsed;
  }
  return {};
};

const shopifyFunctionsCVBDataKey = 'mrSFDCVB';
const getShopifyFunctionsCVBData = () => {
  const data = sessionStorage.getItem(shopifyFunctionsCVBDataKey);
  if (data) {
    const parsed = JSON.parse(data);
    return parsed;
  }
  return {};
};

const setShopifyFunctionsCVBData = data => {
  sessionStorage.setItem(shopifyFunctionsCVBDataKey, JSON.stringify(data));
};

const getVDProductIDs = ({ offer }) => {
  const {
    primary: { sp_product_id },
    vdAvailingMethod,
  } = offer;

  if (vdAvailingMethod === 'group_of_items') {
    return [];
  }

  return [sp_product_id];
};

const getCommonProductIDs = ({ offer }) => {
  const { offered } = offer;
  return offered.map(product => product.id);
};

const getCVBProductIDsAndMap = ({ offer }) => {
  const { milestones } = offer;
  const productIDs = [];
  const productMinValueMap = {};

  const pushIdAndUpdateMap = (id, minValue) => {
    productIDs.push(id);
    if (productMinValueMap[id]) {
      productMinValueMap[id] = minValue;
    }
  };
  milestones.forEach(milestone => {
    const { rewards, minValue } = milestone;
    const fgs = rewards.filter(reward => reward.rewardType === 'freegift');
    if (fgs) {
      fgs.forEach(fg => {
        const {
          freeGiftSpProductID,
          freeGiftAvailingType,
          rewardProducts,
        } = fg;
        if (freeGiftAvailingType === 'auto_add') {
          pushIdAndUpdateMap(freeGiftSpProductID, minValue);
        } else
          rewardProducts.forEach(product =>
            pushIdAndUpdateMap(product.id, minValue),
          );
      });
    }
  });

  return { productIDs, productMinValueMap };
};

export const getApplicableShopifyFunctionCodes = ({
  mrCart,
  cart_level_discount_applications,
  shopURL,
}) => {
  const data = getShopifyFunctionsProductData();
  const cvbData = getShopifyFunctionsCVBData();
  const productDiscountCodeMap = {};
  const setMap = (key, val) => {
    if (productDiscountCodeMap[key]) {
      productDiscountCodeMap[key].push(val);
      return;
    }
    productDiscountCodeMap[key] = [val];
  };

  const allCodes = [];

  // for some offers we don't have the list of products, so always add that code
  Object.keys(data).forEach(code => {
    const productIDs = data[code];
    productIDs.forEach(id => {
      setMap(id.toString(), code);
    });

    if (!productIDs || productIDs.length === 0) {
      allCodes.push(code);
    }
  });

  mrCart.forEach(item => {
    const { sp_product_id } = item;
    const codes = productDiscountCodeMap[sp_product_id.toString()];
    if (codes && codes.length > 0) {
      allCodes.push(...codes);
    }
  });

  Object.keys(cvbData).forEach(code => {
    if (cvbData[code]) {
      allCodes.push(code);
    }
  });

  const alreadyAppliedCodes = getAlreadyAppliedCodesInCart({
    mrCart,
    cart_level_discount_applications,
    shopURL,
  });

  // if there is a non monk code which was already applied so apply that as well
  for (let i = 0; i < alreadyAppliedCodes.length; i += 1) {
    const code = alreadyAppliedCodes[i];
    const monkCodes = Object.keys(data);
    if (!monkCodes.includes(code)) {
      allCodes.push(code);
    }
  }

  if (allCodes.length > 0) {
    return [...new Set(allCodes)];
  }
  return [];
};

// getAlreadyAppliedCodesInCart this function is used to return some of the codes that are already applied in the cart
// which may or maynot be monk specific, so we always pass them to the storefront cart
export const getAlreadyAppliedCodesInCart = ({
  mrCart,
  cart_level_discount_applications,
  shopURL,
}) => {
  const codes = [];
  if (['marina-group-llc.myshopify.com'].includes(shopURL)) {
    for (let i = 0; i < mrCart.length; i += 1) {
      const { line_level_discount_allocations } = mrCart[i];
      if (line_level_discount_allocations) {
        for (let j = 0; j < line_level_discount_allocations.length; j += 1) {
          const {
            discount_application: { title, type },
          } = line_level_discount_allocations[j];
          if (type === 'discount_code') {
            codes.push(title);
          }
        }
      }
    }

    if (cart_level_discount_applications) {
      for (let i = 0; i < cart_level_discount_applications.length; i += 1) {
        const { title } = cart_level_discount_applications[i];
        codes.push(title);
      }
    }
    return codes;
  }
  return [];
};

export const modifyCartDiscountResponse = async ({
  resp,
  mrCart,
  accessToken,
  countryCode,
  mrOrderID,
  shopURL,
  cartToken,
  cart_level_discount_applications,
  discountCode,
}) => {
  const data = await getStorefrontCartAndAppliedCodes({
    mrCart,
    accessToken,
    countryCode,
    mrOrderID,
    shopURL,
    cartToken,
    cart_level_discount_applications,
    discountCode,
  });

  const { appliedCodes } = data;
  let { storefrontCart } = data;

  if (!appliedCodes || appliedCodes.length === 0) {
    return resp;
  }

  const {
    currencyFormat,
    currencySymbol,
    decimalSymbol,
    thousandSeparator,
    isDiscountApplicableOnCompareAtPrice,
  } = resp;

  logger.log(mrCart, storefrontCart.lines.edges, 'before reorder');
  // if (['healthfabindia.myshopify.com'].includes(shopURL)) {
  // eslint-disable-next-line no-param-reassign
  // mrCart = reOrderBasedOnStorefrontCart({ mrCart, storefrontCart });
  // } else {
  storefrontCart = reOrderBasedOnMrCart({ mrCart, storefrontCart });
  // }

  // reorder if needed
  logger.log(mrCart, storefrontCart.lines.edges, 'after reorder');

  const {
    discountedCart,
    totalOfferPrice,
    totalOfferPriceFloat,
    totalPrice,
  } = storeFrontCartToMonkDiscountedCart({
    mrCart,
    storefrontCart,
    currencyFormat,
    currencySymbol,
    decimalSymbol,
    thousandSeparator,
    isDiscountApplicableOnCompareAtPrice,
  });

  resp.discountedCart = discountedCart;
  resp.isZeroDiscount = appliedCodes.length === 0;
  resp.totalOfferPrice = totalOfferPrice;
  resp.totalOfferPriceFloat = totalOfferPriceFloat;
  resp.totalPrice = totalPrice;
  resp.discount_applicable = appliedCodes.length > 0;
  resp.data = data;
  return resp;
};

export const applyFunctionDiscountOnMrCart = async ({
  mrCart,
  accessToken,
  countryCode,
  mrOrderID,
  shopURL,
  cartToken,
  cart_level_discount_applications,
}) => {
  logger.log(
    'applyFunctionDiscountOnMrCart',
    mrCart,
    accessToken,
    countryCode,
    mrOrderID,
    shopURL,
    cartToken,
    cart_level_discount_applications,
  );
  const data = await getStorefrontCartAndAppliedCodes({
    mrCart,
    accessToken,
    countryCode,
    mrOrderID,
    shopURL,
    cartToken,
    cart_level_discount_applications,
  });

  const { appliedCodes, isStorefrontCart } = data;
  let { storefrontCart } = data;

  let cartLevelDiscountApplications = [];

  if (!appliedCodes || appliedCodes.length === 0) {
    return {
      mrCart,
      appliedCodes: [],
      cart_level_discount_applications: cartLevelDiscountApplications,
      checkoutURL: '',
      isStorefrontCart,
    };
  }

  logger.log('before', storefrontCart.edges);
  // reorder if needed
  storefrontCart = reOrderBasedOnMrCart({ mrCart, storefrontCart });
  logger.log('after', storefrontCart.edges);

  const {
    lines: { edges },
    discountAllocation,
    checkoutUrl,
  } = storefrontCart;
  const newMrCart = [];
  for (let i = 0; i < edges.length; i += 1) {
    const mrCartItem = getMrCartItemFromCartEdge({ edge: edges[i] });
    newMrCart.push(mrCartItem);
  }

  if (discountAllocation) {
    const { title } = discountAllocation;
    cartLevelDiscountApplications = [{ title }];
  }

  return {
    mrCart: newMrCart,
    appliedCodes,
    cart_level_discount_applications: cartLevelDiscountApplications,
    checkoutURL: checkoutUrl,
    isStorefrontCart,
  };
};

export const modifyCVBOffer = async ({
  offer,
  mrCart,
  accessToken,
  countryCode,
  mrOrderID,
  shopURL,
  cartToken,
  cart_level_discount_applications,
}) => {
  if (offer.isCVBAmountUsable || offer.isCVBQuantityUsable) return { offer };

  const {
    appliedCodes,
    storefrontCart,
  } = await getStorefrontCartAndAppliedCodes({
    mrCart,
    accessToken,
    countryCode,
    mrOrderID,
    shopURL,
    cartToken,
    cart_level_discount_applications,
  });

  if (!appliedCodes || appliedCodes.length === 0) {
    return { offer };
  }

  const {
    milestones,
    cvbEligibleProducts,
    reservedItemQuantity,
    isCartQuantityRestricted,
  } = offer;

  const eligibleMap = cvbEligibleProducts
    ? cvbEligibleProducts.reduce((curr, product) => {
        if (product.isValid) curr[product.spVariantID] = true;
        return curr;
      }, {})
    : {};

  const fgMap = {};
  for (let i = 0; i < milestones.length; i += 1) {
    const { rewards: milestoneRewards } = milestones[i];
    for (let j = 0; j < milestoneRewards.length; j += 1) {
      const {
        rewardType,
        freeGiftSpVariantID,
        freeGiftAvailingType,
        rewardProducts,
      } = milestoneRewards[j];
      if (rewardType === 'freegift') {
        if (freeGiftAvailingType === 'auto_add')
          fgMap[freeGiftSpVariantID] = true;
        else
          rewardProducts.forEach(({ variants }) => {
            variants.forEach(({ id }) => {
              fgMap[id] = true;
            });
          });
      }
    }
  }

  const {
    lines: { edges },
  } = storefrontCart;

  let totalQuantity = 0;
  let priceTotal = 0;
  let offerPriceTotal = 0;
  for (let i = 0; i < edges.length; i += 1) {
    const {
      quantity,
      sp_variant_id,
      totalOfferPrice,
      totalPrice,
    } = getDiscountedCartItemFromCartEdge({
      edge: edges[i],
      isUseCompareAtPrice: false,
    });

    logger.log(totalOfferPrice, quantity, i);
    let fgQuantityToCheck = !fgMap[sp_variant_id];
    // if auto remove is off then we check for bogo products
    if (!isCartQuantityRestricted) fgQuantityToCheck = reservedItemQuantity[i];

    // if its not a free gift of cvb and its an eligible product
    // then consider the price and quantity
    if (fgQuantityToCheck && eligibleMap[sp_variant_id]) {
      totalQuantity += quantity;
      offerPriceTotal += parseFloat(totalOfferPrice);
      priceTotal += parseFloat(totalPrice);
    }
  }

  let isUseDiscountedPrice = true;
  if (
    [
      'put-a-case-on-me.myshopify.com',
      'moil-de.myshopify.com',
      'moil-il.myshopify.com',
      'moil-dk.myshopify.com',
      'moil-se.myshopify.com',
      'touched-jewelry.myshopify.com',
    ].includes(shopURL)
  ) {
    isUseDiscountedPrice = false;
  }

  offer.isCVBQuantityUsable = true;
  offer.isCVBAmountUsable = true;
  offer.cvbCartQuantityValue = totalQuantity;
  offer.cvbCartValue = isUseDiscountedPrice ? offerPriceTotal : priceTotal;
  return { offer };
};

export const getMonkFGRuleCodes = (
  freegiftFunnelNameCodes,
  mrDiscountCodesMap,
) => {
  const monkFGRuleCodes = [];
  freegiftFunnelNameCodes.forEach(fgCode => {
    mrDiscountCodesMap[fgCode].codes.forEach(monkCode => {
      monkFGRuleCodes.push(monkCode);
    });
  });
  return monkFGRuleCodes;
};

const getGraphqlCodesWithShopifyApplicableCodes = (
  graphqlCachedData,
  codes,
) => {
  if (graphqlCachedData) {
    if (
      graphqlCachedData &&
      graphqlCachedData.mrSF &&
      graphqlCachedData.mrSF.codes
    ) {
      return [
        ...codes.map(code => code.toUpperCase()),
        ...graphqlCachedData.mrSF.codes,
      ];
    }
  }
  return [];
};
// if code is monk's FG code then returns corrosponding funnel title, else return code as it is
export const getMappedShopifyCode = (discountCode, discountCodesMapping) => {
  if (discountCodesMapping) {
    return (
      Object.keys(discountCodesMapping).find(shopifyCode =>
        discountCodesMapping[shopifyCode].codes.includes(discountCode),
      ) || ''
    );
  }
  return '';
};

const removeShopifyFunctionMapping = discountCode => {
  const data = getShopifyFunctionsProductData();
  Object.keys(data).forEach(key => {
    if (key.toUpperCase() === discountCode.code) {
      delete data[key];
      setShopifyFunctionsProductData(data);
    }
  });
};

export const getStorefrontCartAndAppliedCodes = async ({
  mrCart,
  accessToken,
  countryCode,
  mrOrderID,
  shopURL,
  cartToken,
  cart_level_discount_applications,
  discountCode,
}) => {
  const codes = getApplicableShopifyFunctionCodes({
    mrCart,
    cart_level_discount_applications,
    shopURL,
  });

  if (
    [
      'prickle-uk-production.myshopify.com',
      'raised-by-coyotes.myshopify.com',
      'biblesocks.myshopify.com',
      'mi-rebotica-online.myshopify.com',
      'cura-marketing.myshopify.com',
    ].includes(shopURL)
  ) {
    const code = getCookieValue('discount_code');
    if (code && !codes.includes(code)) {
      codes.push(code);
    }
  }
  const graphqlCachedData = getGraphqlCachedData();
  const mrDiscountCodesMap = getShopifyMonkCodesMapping();
  let mrDiscountCodes = [];
  // applied freeshipping code
  const fsCodes = getFreeShippingCodefromStorage();
  const graphqlCodesWithShopifyApplicableCodes = getGraphqlCodesWithShopifyApplicableCodes(
    graphqlCachedData,
    codes,
  );
  mrDiscountCodes.push(...graphqlCodesWithShopifyApplicableCodes);
  // pushing new applied discount code in the list
  if (discountCode && discountCode.code) {
    const mappedCode = getMappedShopifyCode(
      discountCode.code,
      mrDiscountCodesMap,
    );
    if (mappedCode) {
      mrDiscountCodes.push(mappedCode);
    } else {
      mrDiscountCodes.push(discountCode.code);
    }
  }
  // pushing free-shipping code in list
  if (fsCodes) {
    mrDiscountCodes.push(fsCodes);
  }
  // remove duplicate codes
  mrDiscountCodes = [...new Set(mrDiscountCodes)];

  // remove code from the list, for remove code click
  if (discountCode && discountCode.action === 'remove') {
    // remove funnel name from shopify functions mapping to handle auto remove product when removing free gift code
    removeShopifyFunctionMapping(discountCode);
    const idx = mrDiscountCodes.indexOf(discountCode.code);
    if (idx !== -1) {
      mrDiscountCodes.splice(idx, 1);
    }
  }

  const {
    resp: storefrontCartResp,
    isStorefrontCart,
  } = await createStorefrontCart({
    mrCart,
    discountCodes: mrDiscountCodes,
    accessToken,
    countryCode,
    mrOrderID,
    cartToken,
    shopURL,
  });

  const { errors } = storefrontCartResp;
  if (errors) {
    return { codes: [], storefrontCart: {}, userErrors: [] };
  }

  const {
    data: {
      cartDiscountCodesUpdate: { userErrors, cart: storefrontCart },
    },
  } = storefrontCartResp;

  if (userErrors.length > 0) {
    logger.log(userErrors);
    logRuntimeError({
      errorMessage: `userErrors`,
      errorData: {
        fileName: 'shopifyFunctionsDiscount',
        level: 'error',
        basicOfferData: {
          userErrors,
        },
      },
    });
  }

  let appliedCodes = getAppliedShopifyFunctionCodes({ storefrontCart });
  // combining cart-level discount with line level discounts as well as new entered code.
  appliedCodes = [...appliedCodes, ...mrDiscountCodes];

  // if it's a storefront cart then no need to set the codes in the checkout form
  if (appliedCodes.length > 0 && !isStorefrontCart) {
    setDiscountCodes({ codes: appliedCodes, shopURL });
  }

  return { appliedCodes, storefrontCart, userErrors, isStorefrontCart };
};

function getAppliedShopifyFunctionCodes({ storefrontCart }) {
  const {
    lines: { edges },
  } = storefrontCart;
  const appliedCodes = new Set();
  for (let i = 0; i < edges.length; i += 1) {
    const {
      node: { discountAllocations },
    } = edges[i];

    for (let j = 0; j < discountAllocations.length; j += 1) {
      const {
        code,
        discountedAmount: { amount },
      } = discountAllocations[j];

      if (code && parseFloat(amount) > 0) {
        appliedCodes.add(code);
      }
    }
  }

  if (appliedCodes.size > 0) {
    return [...appliedCodes];
  }
  return [];
}

// function removeAdjacentDuplicates(ids) {
//   return ids.filter((id, index) => index === 0 || id !== ids[index - 1]);
// }

// for old checkout, the cart is created in reverse order
// if we pass [l1, l2, l3] -> it will create [l3, l2, l1]
// const getOrderedStoreFrontCart = ({ mrCart, storefrontCart }) => {
//   const {
//     lines: { edges },
//   } = storefrontCart;

//   const storefrontVariantList = [];
//   for (let i = 0; i < edges.length; i += 1) {
//     const {
//       node: {
//         merchandise: { id },
//       },
//     } = edges[i];
//     storefrontVariantList.push(getIdFromGraphQLID(id));
//   }
//   const target = removeAdjacentDuplicates(storefrontVariantList);

//   const mrCartVariantList = [];
//   for (let i = 0; i < mrCart.length; i += 1) {
//     mrCartVariantList.push(mrCart[i].sp_variant_id);
//   }

//   const source = removeAdjacentDuplicates(mrCartVariantList);
//   if (source.length === target.length) {
//     let isEqual = true;
//     for (let i = 0; i < source.length; i += 1) {
//       if (source[i] !== target[i]) {
//         isEqual = false;
//         break;
//       }
//     }

//     if (!isEqual) {
//       isEqual = true;
//       target.reverse();
//       for (let i = 0; i < source.length; i += 1) {
//         if (source[i] !== target[i]) {
//           isEqual = false;
//           break;
//         }
//       }

//       if (isEqual) {
//         edges.reverse();
//         storefrontCart.lines.edges = edges;
//         return storefrontCart;
//       }
//     }
//   }
//   return storefrontCart;
// };

function reOrderBasedOnMrCart({ mrCart, storefrontCart }) {
  const {
    lines: { edges },
  } = storefrontCart;

  // both should have equal items
  if (mrCart.length !== edges.length) {
    return storefrontCart;
  }

  const modifiedEdges = JSON.parse(JSON.stringify(edges));

  // we need to find the items that need to be swapped
  // if the adjacent items are same then we have to check if the quantites are same, it is possible that the
  // quantites are swapped to we have to fix it.

  // Example:
  // mrCart = [{id:1, quantity: 2}, {id:2, quantity: 1}, {id:2, quantity: 2}]
  // storefrontCart = [{id:1, quantity: 2}, {id:2, quantity: 2}, {id:2, quantity: 1}]
  // as you can see that in the storefront cart the order is reversed, so we need to swap the items

  for (let i = 0; i < modifiedEdges.length; i += 1) {
    // no operation needed on the last item
    if (i === modifiedEdges.length - 1) {
      break;
    }

    const targetCurrentItem = getMrCartItemFromCartEdge({
      edge: modifiedEdges[i],
    });

    const targetNextItem = getMrCartItemFromCartEdge({
      edge: modifiedEdges[i + 1],
    });

    const sourceCurrentItem = mrCart[i];
    const sourceNextItem = mrCart[i + 1];

    // adjacent items are same
    if (
      sourceCurrentItem.sp_variant_id === sourceNextItem.sp_variant_id &&
      arePropertiesEqual(
        sourceCurrentItem.properties,
        sourceNextItem.properties,
      )
    ) {
      // quantites are not equal
      if (sourceCurrentItem.quantity !== targetCurrentItem.quantity) {
        logger.log(sourceCurrentItem, targetCurrentItem);
        // double check equal variant ids
        if (
          sourceCurrentItem.sp_variant_id === targetCurrentItem.sp_variant_id &&
          sourceNextItem.sp_variant_id === targetNextItem.sp_variant_id
        ) {
          if (
            sourceCurrentItem.quantity === targetNextItem.quantity &&
            sourceNextItem.quantity === targetCurrentItem.quantity
          ) {
            // swap the items
            const temp = modifiedEdges[i];
            modifiedEdges[i] = modifiedEdges[i + 1];
            modifiedEdges[i + 1] = temp;
          }
        }
      }
    }
  }

  storefrontCart.lines.edges = modifiedEdges;
  return storefrontCart;
}

function reOrderBasedOnStorefrontCart({ mrCart, storefrontCart }) {
  const {
    lines: { edges },
  } = storefrontCart;

  // both should have equal items
  if (mrCart.length !== edges.length) {
    return storefrontCart;
  }

  const modifiedMrCart = JSON.parse(JSON.stringify(mrCart));

  // we need to find the items that need to be swapped
  // if the adjacent items are same then we have to check if the quantites are same, it is possible that the
  // quantites are swapped to we have to fix it.

  // Example:
  // mrCart = [{id:1, quantity: 2}, {id:2, quantity: 1}, {id:2, quantity: 2}]
  // storefrontCart = [{id:1, quantity: 2}, {id:2, quantity: 2}, {id:2, quantity: 1}]
  // as you can see that in the storefront cart the order is reversed, so we need to swap the items

  for (let i = 0; i < modifiedMrCart.length; i += 1) {
    // no operation needed on the last item
    if (i === modifiedMrCart.length - 1) {
      break;
    }

    const targetCurrentItem = modifiedMrCart[i];
    const targetNextItem = modifiedMrCart[i + 1];

    const sourceCurrentItem = getMrCartItemFromCartEdge({
      edge: edges[i],
    });
    const sourceNextItem = getMrCartItemFromCartEdge({
      edge: edges[i + 1],
    });

    // adjacent items are same
    if (
      sourceCurrentItem.sp_variant_id === sourceNextItem.sp_variant_id &&
      arePropertiesEqual(
        sourceCurrentItem.properties,
        sourceNextItem.properties,
      )
    ) {
      // quantites are not equal
      if (sourceCurrentItem.quantity !== targetCurrentItem.quantity) {
        logger.log(sourceCurrentItem, targetCurrentItem);
        // double check equal variant ids
        if (
          sourceCurrentItem.sp_variant_id === targetCurrentItem.sp_variant_id &&
          sourceNextItem.sp_variant_id === targetNextItem.sp_variant_id
        ) {
          if (
            sourceCurrentItem.quantity === targetNextItem.quantity &&
            sourceNextItem.quantity === targetCurrentItem.quantity
          ) {
            // swap the items
            const temp = modifiedMrCart[i];
            modifiedMrCart[i] = modifiedMrCart[i + 1];
            modifiedMrCart[i + 1] = temp;
          }
        }
      }
    }
  }
  return modifiedMrCart;
}

function arePropertiesEqual(source, target) {
  try {
    let sourceKeys = [];
    let targetKeys = [];
    if (!source) {
      // eslint-disable-next-line no-param-reassign
      source = {};
    }
    if (!target) {
      // eslint-disable-next-line no-param-reassign
      target = {};
    }
    sourceKeys = Object.keys(source);
    targetKeys = Object.keys(target);
    if (sourceKeys.length !== targetKeys.length) {
      return false;
    }

    for (let i = 0; i < sourceKeys.length; i += 1) {
      const key = sourceKeys[i];
      if (source[key] !== target[key]) {
        return false;
      }
    }
    return true;
  } catch (e) {
    logger.log('arePropertiesEqual', e);
    return false;
  }
}

function storeFrontCartToMonkDiscountedCart({
  mrCart,
  storefrontCart,
  currencyFormat,
  currencySymbol,
  decimalSymbol,
  thousandSeparator,
  isDiscountApplicableOnCompareAtPrice,
}) {
  const {
    lines: { edges },
  } = storefrontCart;

  if (mrCart.length !== edges.length) {
    logger.log('merging needed');
  }

  const discountedCart = [];
  let totalOfferPrice = '0';
  let totalPrice = '0';

  let j = 0;
  const storefrontCartItemUsedQty = {};
  const incrementStorefrontCartItemUsedQty = (index, qty) => {
    if (storefrontCartItemUsedQty[index]) {
      storefrontCartItemUsedQty[index] += qty;
      return;
    }
    storefrontCartItemUsedQty[index] = qty;
  };

  const getStorefrontCartItemUsedQty = index => {
    if (storefrontCartItemUsedQty[index]) {
      return storefrontCartItemUsedQty[index];
    }
    return 0;
  };

  for (let i = 0; i < mrCart.length; i += 1) {
    const { quantity } = mrCart[i];
    const discountedCartItem = getDiscountedCartItemFromCartEdge({
      edge: edges[j],
      isUseCompareAtPrice: isDiscountApplicableOnCompareAtPrice,
    });

    while (discountedCartItem.quantity < quantity) {
      logger.log('quantity less', discountedCartItem.quantity, quantity, j);
      // next item
      j += 1;
      const nextItem = getDiscountedCartItemFromCartEdge({
        edge: edges[j],
      });
      discountedCartItem.quantity += nextItem.quantity;

      // add offer prices
      discountedCartItem.totalOfferPrice = addStringPrices([
        discountedCartItem.totalOfferPrice,
        nextItem.totalOfferPrice,
      ]);

      // add total prices
      discountedCartItem.totalPrice = addStringPrices([
        discountedCartItem.totalPrice,
        nextItem.totalPrice,
      ]);
    }

    // store frontcart has less items so split the store front item into multiple items
    // we need to track the quantites used from the current line item as well so that
    // we are not stuck in an infinite loop
    if (
      quantity <
      discountedCartItem.quantity - getStorefrontCartItemUsedQty(j)
    ) {
      const offerPrice =
        parseFloat(discountedCartItem.totalOfferPrice) /
        discountedCartItem.quantity;

      const price =
        parseFloat(discountedCartItem.totalPrice) / discountedCartItem.quantity;

      discountedCartItem.quantity = quantity;
      discountedCartItem.totalOfferPrice = (offerPrice * quantity).toFixed(2);
      discountedCartItem.totalPrice = (price * quantity).toFixed(2);
      incrementStorefrontCartItemUsedQty(j, quantity);
    } else {
      // increment j as we can move on to the next store front cart item

      j += 1;
      logger.log('increment j', j);
    }

    logger.log(mrCart[i], edges[j], 'current');

    totalOfferPrice = addStringPrices([
      totalOfferPrice,
      discountedCartItem.totalOfferPrice,
    ]);

    totalPrice = addStringPrices([totalPrice, discountedCartItem.totalPrice]);

    discountedCartItem.totalPrice = currencyFormat
      .replace(
        '{{amount}}',
        formatWithSymbolAndSeparator({
          val: discountedCartItem.totalPrice,
          decimalSymbol,
          thousandSeparator,
        }),
      )
      .replace('{{currencySymbol}}', currencySymbol);

    discountedCartItem.totalOfferPrice = currencyFormat
      .replace(
        '{{amount}}',
        formatWithSymbolAndSeparator({
          val: discountedCartItem.totalOfferPrice,
          decimalSymbol,
          thousandSeparator,
        }),
      )
      .replace('{{currencySymbol}}', currencySymbol);

    discountedCart.push(discountedCartItem);
  }

  const totalOfferPriceFloat = parseFloat(totalOfferPrice);
  if (
    storefrontCart.discountAllocations &&
    storefrontCart.discountAllocations.length
  ) {
    storefrontCart.discountAllocations.forEach(
      ({ discountedAmount: { amount } }) => {
        totalOfferPrice = parseFloat(totalOfferPrice) - parseFloat(amount);
      },
    );
  }
  totalOfferPrice = currencyFormat
    .replace(
      '{{amount}}',
      formatWithSymbolAndSeparator({
        val: totalOfferPrice,
        decimalSymbol,
        thousandSeparator,
      }),
    )
    .replace('{{currencySymbol}}', currencySymbol);
  totalPrice = currencyFormat
    .replace(
      '{{amount}}',
      formatWithSymbolAndSeparator({
        val: totalPrice,
        decimalSymbol,
        thousandSeparator,
      }),
    )
    .replace('{{currencySymbol}}', currencySymbol);

  return { totalOfferPriceFloat, totalOfferPrice, totalPrice, discountedCart };
}

const getDiscountedCartItemFromCartEdge = ({
  edge,
  isUseCompareAtPrice = false,
}) => {
  const {
    node: {
      quantity,
      cost: {
        subtotalAmount: { amount: subtotal },
        totalAmount: { amount: totalOfferPrice },
        compareAtAmountPerQuantity,
      },
      merchandise: {
        id,
        product: { id: productID },
      },
    },
  } = edge;

  // if compare at price has to be used then check if its present and use
  let totalPrice = subtotal;
  if (isUseCompareAtPrice && compareAtAmountPerQuantity) {
    const { amount } = compareAtAmountPerQuantity;
    totalPrice = (parseFloat(amount) * quantity).toFixed(2);
  }

  return {
    quantity,
    totalPrice: parseFloat(totalPrice).toFixed(2),
    totalOfferPrice: parseFloat(totalOfferPrice).toFixed(2),
    sp_variant_id: getIdFromGraphQLID(id),
    sp_product_id: getIdFromGraphQLID(productID),
  };
};

const getMrCartItemFromCartEdge = ({ edge }) => {
  const {
    node: {
      quantity,
      attributes,
      sellingPlanAllocation,
      discountAllocations,
      merchandise: {
        id: sp_variant_id,
        product: { id: sp_product_id },
      },
    },
  } = edge;

  const item = {
    sp_product_id: getIdFromGraphQLID(sp_product_id),
    sp_variant_id: getIdFromGraphQLID(sp_variant_id),
    quantity,
  };

  const properties = {};
  const propertiesOrder = [];
  if (attributes) {
    for (let i = 0; i < attributes.length; i += 1) {
      const { key, value } = attributes[i];
      properties[key] = value;
      propertiesOrder.push(key);
    }
    item.properties = properties;
    item.properties_order = propertiesOrder;
  }

  if (sellingPlanAllocation) {
    const { sellingPlan } = sellingPlanAllocation;
    const { id } = sellingPlan;
    item.selling_plan_allocation = {
      selling_plan: { id: getIdFromGraphQLID(id) },
    };
  }

  if (discountAllocations) {
    item.line_level_discount_allocations = discountAllocations.map(
      discountAllocation => {
        const {
          discountedAmount: { amount },
          title,
          code,
        } = discountAllocation;
        return {
          amount: Math.round(parseFloat(amount) * 100),
          discount_application: { title: title || code },
        };
      },
    );
  }
  return item;
};

const addStringPrices = prices => {
  let total = 0;
  for (let i = 0; i < prices.length; i += 1) {
    total += parseFloat(prices[i]);
  }
  return total.toFixed(2);
};

const getIdFromGraphQLID = gid => {
  const idSplit = gid.split('/');
  return parseInt(idSplit[idSplit.length - 1], 10);
};

const setDiscountCodes = ({ codes, shopURL }) => {
  const fields = createDiscountFormField({ shopURL });
  for (let i = 0; i < fields.length; i += 1) {
    fields[i].value = codes.join(',');
  }
  updateCheckoutHrefs({ codes });
};

const updateCheckoutHrefs = ({ codes }) => {
  // / Select all elements with href starting with "/checkout"
  const checkoutLinks = document.querySelectorAll('[href^="/checkout"]');

  // Iterate over each selected element
  Array.from(checkoutLinks).forEach(link => {
    // Split the href attribute value by "?" and filter out any query parameters with "discount="
    const queryParams = link
      .getAttribute('href')
      .split('?')
      .filter(param => param.indexOf('discount=') === -1);

    // Take the first part of the href (before "?") and trim any leading or trailing spaces
    const baseHref = queryParams.shift().trim();

    // Append the "discount" query parameter with the value of discountValue
    queryParams.push(`discount=${codes.join(',')}`);

    // Recreate the modified href with the new query parameter
    const updatedHref = `${baseHref}?${queryParams.join('&')}`;

    // Set the updated href attribute
    link.setAttribute('href', updatedHref);
  });
};

const createDiscountFormField = ({ shopURL }) => {
  let name = 'discount';
  if (shopURL === 'muse-india.myshopify.com') {
    name = 'monk-discount';
  }

  // get all checkout forms
  const checkoutForms = document.querySelectorAll(
    'form[action*="/cart"][method=post]:not([action*="/cart/add"])',
  );
  for (let i = 0; i < checkoutForms.length; i += 1) {
    if (
      checkoutForms[i].querySelectorAll(`input[type=hidden][name=${name}]`)
        .length === 0
    ) {
      const discountNode = document.createElement('input');
      discountNode.type = 'hidden';
      discountNode.name = name;
      checkoutForms[i].append(discountNode);
    }
  }
  return document.querySelectorAll(`input[name=${name}]`);
};
